module.exports = __webpack_public_path__ + "img/ph_qrcode_whatsapp.f243abf.webp";